export { default } from './SupersearchHistory';
